import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setXIdSociete } from '@europrocurement/l2d-domain';
import useLoadStore, { LoadableCollection } from '@europrocurement/l2d-modules/hooks/useLoadStore';
import useLoadLibArticle from '@europrocurement/l2d-modules/hooks/useLoadLibArticle';

import useOfferCache from '../cache/useOfferCache';

const L2D_SOCIETE_ID = 12;

const COLLECTIONS_TO_FETCH: LoadableCollection[] = [
    'vats',
    'domains',
    'regleDeCalculs',
    'invoicingCategories',
    'formalityCategories',
    'articlesCategories',
    'origines',
];

/**
 * Charge les données partagées nécessaires aux écrans de configuration des offres
 * (caches, articles de la librairie, collections du store) et expose l'état de chargement.
 *
 * Mutualisé entre les dashboards "Configuration des offres commerciales" et
 * "Configuration technique".
 */
const useOffresDashboardData = (): { isLoading: boolean } => {
    const dispatch = useDispatch();

    useOfferCache();
    useLoadLibArticle();

    const { getLoadingStatus } = useLoadStore(COLLECTIONS_TO_FETCH);

    const loadingStatus = getLoadingStatus();

    /**
     * Latch de premier chargement : une fois toutes les collections chargées une
     * première fois, on ne réaffiche plus le skeleton. Sans ce verrou, un re-fetch
     * d'une collection surveillée (ex. `articles-categories`, utilisée à la fois par
     * le gate et par le listing des catégories) repasserait `isLoading` à true et
     * démonterait l'Outlet, provoquant une boucle remontage ↔ fetch.
     */
    const [initialLoadDone, setInitialLoadDone] = useState(false);

    useEffect(() => {
        if (loadingStatus === 'succeeded') {
            setInitialLoadDone(true);
        }
    }, [loadingStatus]);

    const isLoading = !initialLoadDone && (loadingStatus === 'loading' || loadingStatus === 'idle');

    useEffect(() => {
        dispatch(setXIdSociete(L2D_SOCIETE_ID));
    }, [dispatch]);

    return { isLoading };
};

export default useOffresDashboardData;
